'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _reactCustomScrollbars = require('react-custom-scrollbars');

require('./OverlayContainer.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayContainer = function (_Component) {
  (0, _inherits3.default)(OverlayContainer, _Component);

  function OverlayContainer() {
    (0, _classCallCheck3.default)(this, OverlayContainer);
    return (0, _possibleConstructorReturn3.default)(this, (OverlayContainer.__proto__ || (0, _getPrototypeOf2.default)(OverlayContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(OverlayContainer, [{
    key: 'onClick',
    value: function onClick(e) {
      e.preventDefault();
      this.props.closeCallback();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classname2.default)("OverlayContainer", { 'is-open': this.props.isOpen }) },
        _react2.default.createElement('a', { href: '#', className: 'OverlayContainer__close icon icon-cross no-text-decoration', onClick: this.onClick.bind(this) }),
        _react2.default.createElement(
          'div',
          { className: 'OverlayContainer__content' },
          _react2.default.createElement(
            _reactCustomScrollbars.Scrollbars,
            {
              hideTracksWhenNotNeeded: true,
              renderTrackVertical: function renderTrackVertical(props) {
                return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'Scrollbars__track-vertical' }));
              },
              renderThumbVertical: function renderThumbVertical(props) {
                return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'Scrollbars__thumb-vertical' }));
              },
              renderView: function renderView(props) {
                return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'Scrollbars__view' }));
              }
            },
            this.props.children
          )
        )
      );
    }
  }]);
  return OverlayContainer;
}(_react.Component);

OverlayContainer.propTypes = {
  isOpen: _propTypes2.default.bool,
  closeCallback: _propTypes2.default.func
};

OverlayContainer.defaultProps = {
  isOpen: false,
  closeCallback: function closeCallback() {}
};

exports.default = OverlayContainer;


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/OverlayContainer/OverlayContainer.js
// module id = 1171
// module chunks = 0